import { render, staticRenderFns } from "./BacBlueButton.vue?vue&type=template&id=207f4431&scoped=true&"
var script = {}
import style0 from "./BacBlueButton.vue?vue&type=style&index=0&id=207f4431&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207f4431",
  null
  
)

export default component.exports